const FIRST_STEP = 0;
const SECOND_STEP = 1;

const BOOKING_DEFAULT_STATE = {
  userData: {
    first_name: '',
    last_name: '',
    email: '',
    handicap: '',
    gender: ''
  },
  touchedFields: [],
  errors: {},
  isValid: false,
  isSubmitting: false,
  step: FIRST_STEP,
  event: null,
  price: null,
  isLoading: true,
  hasFetchError: false
};

const getBookingDefaultState = () => {
  return Object.assign({}, BOOKING_DEFAULT_STATE);
};

const BOOKING_CONFIG = [
  {
    fields: [
      {
        key: 'first_name',
        fieldType: 'input', // -> constants
        label: 'booking.form.placeholder_firstname_input',
        autoComplete: 'given-name'
      },
      {
        key: 'last_name',
        fieldType: 'input', // -> constants
        label: 'booking.form.placeholder_lastname_input',
        autoComplete: 'family-name'
      },
      {
        key: 'email',
        fieldType: 'input', // -> constants
        inputType: 'email',
        label: 'booking.form.placeholder_email_input',
        autoComplete: 'email'
      }
    ],
    constraints: {
      first_name: {
        presence: true
      },
      last_name: {
        presence: true
      },
      email: {
        presence: true,
        email: true
      },
    }
  },
  {
    fields: [
      {
        key: 'phone',
        fieldType: 'input', // -> constants
        inputType: 'tel',
        label: 'booking.form.placeholder_phone_input',
        autoComplete: 'tel-national'
      },
      {
        key: 'handicap',
        fieldType: 'input',
        inputType: 'number',
        // inputMin: 0,
        // inputMax: 54,
        label: 'booking.form.placeholder_handicap_input',
      },
      {
        key: 'gender',
        fieldType: 'select',
        label: 'booking.form.placeholder_gender_input',
        options: [
          {
            key: 'Male',
            label: 'booking.form.option_gender_male'
          },
          {
            key: 'Female',
            label: 'booking.form.option_gender_female'
          },
          {
            key: 'Prefer not to disclose',
            label: 'booking.form.option_gender_not_disclosed'
          },
        ]
      },
    ],
    constraints: {
      phone: {},
      handicap: {
        /*,
          numericality: {
            lessThan: 55,
            greaterThan: -1,
            onlyInteger: true,
            strict: true,
          }*/
      },
      gender: {
        presence: true,
      }
    }
  }
];

const getBookingConfiguration = () => {
  return JSON.parse(JSON.stringify(BOOKING_CONFIG));
};

const getSetsterLocationID = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'ie':
    case 'test':
      return 24696;
    default:
      return 25021;
  }
};

const PAYMENT_TYPE_CREDIT_CARD = 'credit_card';
const PAYMENT_TYPE_CASH = 'cash';
const POSTAGE_AMOUNT = 5;

export {
  BOOKING_DEFAULT_STATE,
  getBookingDefaultState,
  BOOKING_CONFIG,
  getBookingConfiguration,
  FIRST_STEP,
  SECOND_STEP,
  getSetsterLocationID,
  PAYMENT_TYPE_CASH,
  PAYMENT_TYPE_CREDIT_CARD,
  POSTAGE_AMOUNT,
}



// WEBPACK FOOTER //
// ./src/utils/booking-config.js